import { combineReducers } from "redux";
import { SEND_LINK } from "../constants/send-link";
import { getErrorReducer, getStatusReducer } from "../utils/reducer-generators";

export default combineReducers({
  status: getStatusReducer([SEND_LINK]),
  error: getErrorReducer([SEND_LINK]),
});
